import { render, staticRenderFns } from "./CoffInputTextEditor.vue?vue&type=template&id=3842374b&scoped=true"
import script from "./CoffInputTextEditor.vue?vue&type=script&lang=js"
export * from "./CoffInputTextEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3842374b",
  null
  
)

export default component.exports